import {
  Container,
  Grid,
  Box,
  Button,
  Slide,
  Paper,
  Typography,
  useTheme,
  Snackbar,
  makeStyles,IconButton,Tooltip
} from "@material-ui/core";
import { useState, useEffect } from "react";
import parse from "html-react-parser";
import Axios from "axios";
import LinkIcon from '@material-ui/icons/Link';
import { Helmet } from "react-helmet-async";

import { Loading } from "../../components/shared/loading";

import PhoneIcon from "@material-ui/icons/Phone";

import { Link, useParams } from "react-router-dom";

import {
  EmailShareButton,
  EmailIcon,
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  PinterestShareButton,
  PinterestIcon,
 // RedditShareButton,
 // RedditIcon,
  XIcon,
  TelegramShareButton,
  TelegramIcon,
  TwitterShareButton,
  TwitterIcon,
 // ViberShareButton,
  WhatsappShareButton,
  WhatsappIcon,RedditIcon, RedditShareButton
  
} from "react-share";
import MuiAlert from "@material-ui/lab/Alert";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    position: "relative",
    minHeight: "35vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "linear-gradient(rgba(76, 0, 76, 0.85), rgba(76, 0, 76, 0.9))",
    },
  },
  heroContent: {
    position: "relative",
    zIndex: 1,
    textAlign: "center",
    color: "#ffffff",
    padding: "40px 20px",
    maxWidth: 700,
  },
  heroTitle: {
    fontSize: "clamp(1.8rem, 4vw, 2.5rem)",
    fontWeight: 700,
    marginBottom: 10,
    textShadow: "0 2px 15px rgba(0,0,0,0.3)",
  },
  heroDivider: {
    width: 40,
    height: 2,
    background: "rgba(255,255,255,0.5)",
    margin: "12px auto",
    borderRadius: 2,
  },
  heroSubtitle: {
    fontSize: "clamp(0.85rem, 1.5vw, 1rem)",
    fontWeight: 400,
    opacity: 0.9,
    maxWidth: 500,
    margin: "0 auto",
    lineHeight: 1.5,
  },
  pageWrapper: {
    background: "#fafafa",
    paddingTop: 40,
    paddingBottom: 60,
  },
  contentContainer: {
    background: "#ffffff",
    borderRadius: 20,
    boxShadow: "0 8px 40px rgba(0,0,0,0.08)",
    overflow: "hidden",
    border: "1px solid rgba(76, 0, 76, 0.05)",
  },
  serviceHeader: {
    padding: 0,
  },
  serviceImageWrapper: {
    position: "relative",
    width: "100%",
    overflow: "hidden",
  },
  serviceImage: {
    width: "100%",
    height: 280,
    objectFit: "cover",
    [theme.breakpoints.down('sm')]: {
      height: 200,
    },
  },
  serviceImageOverlay: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    background: "linear-gradient(transparent, rgba(0,0,0,0.4))",
    height: 100,
  },
  serviceMeta: {
    padding: "24px 32px",
    [theme.breakpoints.down('sm')]: {
      padding: "20px",
    },
  },
  serviceTitle: {
    fontSize: "1.3rem",
    fontWeight: 600,
    color: "#1a1a1a",
    marginBottom: 12,
    [theme.breakpoints.down('sm')]: {
      fontSize: "1.15rem",
    },
  },
  serviceTagline: {
    fontSize: "0.85rem",
    color: "#666666",
    marginBottom: 16,
    lineHeight: 1.5,
  },
  shareSection: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap",
    padding: "16px 32px",
    background: "#fafafa",
    borderTop: "1px solid #f0f0f0",
    borderBottom: "1px solid #f0f0f0",
    [theme.breakpoints.down('sm')]: {
      padding: "12px 20px",
    },
  },
  shareLabel: {
    fontSize: "0.8rem",
    fontWeight: 600,
    color: "#4c004c",
  },
  shareButton: {
    transition: "transform 0.2s ease",
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
  serviceContent: {
    padding: "32px",
    [theme.breakpoints.down('sm')]: {
      padding: "24px 20px",
    },
  },
  serviceBody: {
    fontSize: "0.95rem",
    color: "#333333",
    lineHeight: 1.8,
    "& p": {
      marginBottom: 16,
    },
    "& ul, & ol": {
      paddingLeft: 24,
      marginBottom: 16,
    },
    "& li": {
      marginBottom: 8,
    },
    "& h1, & h2, & h3, & h4": {
      color: "#4c004c",
      marginTop: 24,
      marginBottom: 12,
    },
    "& img": {
      maxWidth: "100%",
      borderRadius: 8,
      margin: "16px 0",
    },
  },
  ctaSection: {
    background: "linear-gradient(135deg, #6b1b6b 0%, #4a0e4a 100%)",
    borderRadius: 12,
    padding: "32px 24px",
    marginTop: 32,
    textAlign: "center",
  },
  ctaTitle: {
    fontSize: "1.1rem",
    color: "#ffffff",
    fontWeight: 600,
    marginBottom: 16,
  },
  ctaButton: {
    backgroundColor: "#ffffff",
    color: "#6b1b6b",
    padding: "10px 24px",
    fontSize: "0.85rem",
    fontWeight: 500,
    borderRadius: "25px",
    textTransform: "none",
    boxShadow: "0 2px 12px rgba(0,0,0,0.15)",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#f5f5f5",
      transform: "translateY(-2px)",
    },
  },
  backLink: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    fontSize: "0.85rem",
    color: "#6b1b6b",
    fontWeight: 500,
    textDecoration: "none",
    marginBottom: 20,
    "&:hover": {
      textDecoration: "none",
      color: "#4c004c",
    },
  },
}));


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}


export const ServiceDetails = () => {
  const classes = useStyles();
  const theme = useTheme();
  let { id } = useParams();
  const url=window.location.href;
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDesc, setMetaDesc] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [isloading, setIsloading] = useState(true);
  const [service, setService] = useState(true);


  const [snackBar, setSnackBar] = useState(false);
  const [snackBarMsg, setSnackBarMsg] = useState("success");
  const [snackBarType, setSnackBarType] = useState("Invalid");

  const openSnkbar = (type, msg) => {
    setSnackBarMsg(msg);
    setSnackBarType(type);
    setSnackBar(true);
  };


  const handleClick = () => {
    const anchor = document.querySelector("#back-to-top-anchor");

    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };


  const [tooltipText, setTooltipText] = useState("Click to copy the URL");

  const handleCopy = () => {
    // Copy the URL to clipboard
    navigator.clipboard.writeText(window.location.href)
      .then(() => {
        setTooltipText("Link copied to clipboard!"); // Update tooltip text
        setTimeout(() => setTooltipText("Click to copy the URL"), 2000); // Reset tooltip text after 2 seconds
      })
      .catch((err) => console.error("Failed to copy: ", err));
  };

  useEffect(() => {
    getMetaData();
  }, []);

  const getMetaData = () => {
    const formData = new FormData();
    formData.append("id", id);

    Axios.post("/api/getsingleservice", formData, {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.data.status) {
        setMetaTitle(res.data.data.serv_title);
        setMetaKeywords(res.data.data.serv_keywords);
        setMetaDesc(res.data.data.serv_metadesc);
        setService(res.data.data);
        setIsloading(false);
        handleClick();
      }
    });
  };

  return (
    <div>
      {service && !isloading ? (
        <div>
          <Helmet>
            <title>{metaTitle + " | Arawinz Soft Solutions"}</title>
            <meta name="description" content={metaDesc} />
            <meta name="keywords" content={metaKeywords}></meta>
          </Helmet>

          {/* Hero Section */}
          <Box 
            className={classes.heroSection}
            style={{ backgroundImage: `url("/static/services/${service.serv_image}")` }}
          >
            <Box className={classes.heroContent}>
              <Typography className={classes.heroTitle}>
                {service.serv_name}
              </Typography>
              <Box className={classes.heroDivider} />
              <Typography className={classes.heroSubtitle}>
                Professional IT Solutions by Arawinz
              </Typography>
            </Box>
          </Box>

          {/* Content Section */}
          <Box className={classes.pageWrapper}>
            <Container maxWidth="md">
              {/* Back Link */}
              <Link to="/our-services" className={classes.backLink}>
                ← Back to Services
              </Link>

              {/* Service Card */}
              <Box className={classes.contentContainer}>
                {/* Image Section */}
                <Box className={classes.serviceHeader}>
                  <Box className={classes.serviceImageWrapper}>
                    <img
                      src={`/static/services/${service.serv_image}`}
                      alt={service.serv_name}
                      className={classes.serviceImage}
                    />
                    <Box className={classes.serviceImageOverlay} />
                  </Box>
                </Box>

                {/* Meta Section */}
                <Box className={classes.serviceMeta}>
                  <Typography className={classes.serviceTitle}>
                    {service.serv_name}
                  </Typography>
                  <Typography className={classes.serviceTagline}>
                    Expert solutions tailored to your business needs
                  </Typography>
                </Box>

                {/* Share Section */}
                <Box className={classes.shareSection}>
                  <Typography className={classes.shareLabel}>Share:</Typography>
                  <FacebookShareButton url={url} className={classes.shareButton}>
                    <FacebookIcon size={24} round />
                  </FacebookShareButton>
                  <LinkedinShareButton url={url} className={classes.shareButton}>
                    <LinkedinIcon size={24} round />
                  </LinkedinShareButton>
                  <TwitterShareButton url={url} className={classes.shareButton}>
                    <XIcon size={24} round />
                  </TwitterShareButton>
                  <WhatsappShareButton url={url} className={classes.shareButton}>
                    <WhatsappIcon size={24} round />
                  </WhatsappShareButton>
                  <TelegramShareButton url={url} className={classes.shareButton}>
                    <TelegramIcon size={24} round />
                  </TelegramShareButton>
                  <EmailShareButton url={url} className={classes.shareButton}>
                    <EmailIcon size={24} round />
                  </EmailShareButton>
                  <Tooltip title={tooltipText} arrow>
                    <IconButton onClick={handleCopy} size="small">
                      <LinkIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>

                {/* Service Content */}
                <Box className={classes.serviceContent}>
                  <Box className={classes.serviceBody}>
                    {parse(service.serv_desc)}
                  </Box>
                </Box>
              </Box>

              {/* CTA Section */}
              <Box className={classes.ctaSection}>
                <Typography className={classes.ctaTitle}>
                  Ready to Get Started? Let's Discuss Your Requirements
                </Typography>
                <Button
                  component={Link}
                  to="/get-in-touch"
                  className={classes.ctaButton}
                  startIcon={<PhoneIcon />}
                >
                  Contact Us
                </Button>
              </Box>

              {/* Snackbar */}
              <Snackbar
                open={snackBar}
                autoHideDuration={4000}
                onClose={() => setSnackBar(false)}
              >
                <Alert
                  onClose={() => setSnackBar(false)}
                  severity={snackBarType}
                  style={{ color: snackBarType === "warning" ? "black" : "white" }}
                >
                  {snackBarMsg}
                </Alert>
              </Snackbar>
            </Container>
          </Box>
        </div>
      ) : (
        <Loading />
      )}
    </div>
  );
};

